import React, {useState, useEffect} from "react";
import { Block, BlockContent, BlockDes, BlockHead, BlockTitle, Button, PreviewCard } from "../../components/Component";
import Logo from "../../images/logo.png";
import LogoDark from "../../images/logo-dark.png";
import {Form, FormGroup, Spinner, Toast, ToastHeader, ToastBody } from "reactstrap";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { Link } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { loginAxios } from '../../config/axios.config';
import { toast, ToastContainer } from "react-toastify";

const ForgotPassword = () => {

  const { errors, register, handleSubmit } = useForm();

  // const [visible, setVisible] = useState(false)
	// const [toastMsg, setToastMsg] = useState('');


	// const handleToastVisible = (msg) => {
	// 	setVisible(true);
	// 	setToastMsg(msg);
	// 	setTimeout(() => {
	// 		setVisible(false);
	// 		setToastMsg('');
	// 	}, 1500)

	// }

	const resetPasswordCall = async (params) => {
		try {
			const { data } = await loginAxios.post("designers/forgot-password", params);
			return data;

		} catch (error) {
			return Promise.reject(error);
		}
	};

  const resetPassword = useMutation(resetPasswordCall, {
    onSettled(data, error) {
      if (data) {
        // console.log('found data')
        // console.log(data);
        // handleToastVisible(data.message);
        console.log(data.message)
        toast.success(data.message, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: true,
					closeOnClick: true,
					progress: false,
				  });

      } else if (error) {
        // console.log('found ERROR')
        // console.log();
        // handleToastVisible(error.response.data.message);

        console.log(error.response.data.message);
        toast.error(error.response.data.message, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: true,
					closeOnClick: true,
					progress: false,
				  });
      }
    }
  })


    
  const onFormSubmit = (data) => {
    console.log(data);
    resetPassword.mutate(data);

  };


  return (
    <React.Fragment>
      <Head title="Forgot-Password" />
      <PageContainer>
        
				{/* <div style={{ position: "fixed", top: 10, right: 10, zIndex: 9999 }}>
					<Toast isOpen={visible}>
						<ToastHeader>
              Toast title
            </ToastHeader>
						<ToastBody>
							{toastMsg}
						</ToastBody>
					</Toast>
				</div> */}

        <Block className="nk-block-middle nk-auth-body  wide-xs">
          <div className="brand-logo pb-4 text-center">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
            </Link>
          </div>
          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            <BlockHead>
              <BlockContent>
                <BlockTitle tag="h5">Reset password</BlockTitle>
                <BlockDes>
                  <p>If you forgot your password, well, then we’ll email you instructions to reset your password.</p>
                </BlockDes>
              </BlockContent>
            </BlockHead>

            <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Email
                  </label>
                </div>
                <div className="form-control-wrap">
                  <input
                    type="text"
                    id="default-01"
                    name="email"
                    ref={register({
                      required: 'This field is required',
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Please enter valid email-id",
                      },
                    })}                    
                    placeholder="Enter your email address"
                    className="form-control-lg form-control"
                  />
                  {errors.email && <span className="invalid">{errors.email.message}</span>}
                </div>
              </FormGroup>

              <FormGroup>
                <Button color="primary" size="lg" className="btn-block" type="submit">                  
                  {resetPassword.isLoading ? <Spinner size="sm" color="light" /> : "Send Reset Link"}
                </Button>                
              </FormGroup>
            </Form>
            <div className="form-note-s2 text-center pt-4">
              <Link to={`${process.env.PUBLIC_URL}/auth-login`}>
                <strong>Return to login</strong>
              </Link>
            </div>
          </PreviewCard>
        </Block>
        {/* <AuthFooter /> */}
      </PageContainer>
      <ToastContainer />
    </React.Fragment>
  );
};
export default ForgotPassword;
